import { render, staticRenderFns } from "./EditStudentCreditsModal.vue?vue&type=template&id=14bc1750&scoped=true&"
import script from "./EditStudentCreditsModal.vue?vue&type=script&lang=js&"
export * from "./EditStudentCreditsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditStudentCreditsModal.vue?vue&type=style&index=0&id=14bc1750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bc1750",
  null
  
)

export default component.exports